import React, { FC, Fragment } from 'react'
import { Button, Card, Grid, makeStyles, Container, Typography } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { Route, Switch } from 'react-router-dom'
import Statistics from './statistics'
import TransactionStatistics from './transactions'
import AlarmsStatistics from './alarms'
import CardStatistics from './cardtypes'
import EmptyingStatistics from './emptying'
import DigitalLicensesStatistics from './digitallicenses'
import {ReactComponent as SvgCards} from './icons/cards.svg'
import {ReactComponent as SvgCoins} from './icons/coins.svg'
import {ReactComponent as SvgApp} from './icons/app.svg'
import {ReactComponent as SvgAlerts} from './icons/alerts.svg'
import {ReactComponent as PngDigital} from './icons/black_car.svg'
import { TokenStorage } from '../../api/auth/TokenStorage'

const useStyles = makeStyles((theme) => ({
    paper: {
        [theme.breakpoints.up('sm')]: {
            padding: '0',
        },
        marginTop: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    buts: {
        width: '100%',
        height: '100%',
        margin: '8px'
    },
    grid: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    textHelp: {
        marginBottom: '1rem'
    },
    margTop: {
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(2),
    },
    boxArea: {
        display: 'flex',
        marginTop: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap'
    },
    boxes: {
        width: 300,
        border: 1,
        paddingRight: 5,
        paddingLeft: 5
    },
    cardBox: {
        height: 100,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex'
    },
    svg: {
        display: 'inline-block',
        paddingRight: 5,
        paddingLeft: 5
    }
}))

const InternalNavigation: FC = () => {
    const classes = useStyles()
    const history = useHistory()

    const pageCardtypes = 0
    const pageTransactions = 1
    const pageEmptyingCoins = 2
    const pageAlarms = 3
    const pageDigitalLicenses = 4

    var url = ""
    const changePage = (page: number) => {
        switch (page) {
        case pageCardtypes: // Cardtypes
            url = "/statistics/cardtypes"
            break
        case pageEmptyingCoins: // Emptying
            url = "/statistics/emptying"
            break
        case pageTransactions: // Transactions
            url = "/statistics/transactions"
            break
        case pageAlarms: // Alarms and events
            url = "/statistics/alarms"
            break
        case pageDigitalLicenses:
        url = "/statistics/digital_licenses"
        break
        case 10: // All
            url = "/statistics/all"
            break
        default:
            // Does not make sense
            return
        }
        history.push(url, page)
    }

    const statIcons = (page: number) => {
        switch (page) {

            case pageTransactions:
                return (
                    <div className={classes.cardBox}>
                        <div className={classes.svg}><SvgApp width="80" height="80"/></div>
                        <div className={classes.svg}><SvgCards width="80" height="80"/></div>
                        <div className={classes.svg}><SvgCoins width="80" height="80"/></div>
                    </div>
                )

            case pageCardtypes:
                return (
                    <div className={classes.cardBox}>
                        <div className={classes.svg}><SvgCards width="80" height="80"/></div>
                    </div>
                )
            
            case pageEmptyingCoins:
                return (
                    <div className={classes.cardBox}>
                        <div className={classes.svg}><SvgCoins width="80" height="80"/></div>
                    </div>
                )
            case pageAlarms:
                return (
                    <div className={classes.cardBox}>
                        <div className={classes.svg}><SvgAlerts width="80" height="80"/></div>
                    </div>
                )
            case pageDigitalLicenses:
                return (
                    <div className={classes.cardBox}>
                        <div className={classes.svg}><PngDigital width="120" height="120" /></div>
                    </div>
                )
            }
        return (<div className={classes.cardBox}/>)
    }

    const statLinks = (page: number, name: string) => {
        return (
            <div className={classes.boxes}>
            <Grid container>
                <Grid item xs={12}>
                    <Card onClick={() => changePage(page)}>
                        {statIcons(page)}
                    </Card>
                </Grid>
                {/*<Grid item xs={4}>
                    <Button color="primary" onClick={() => changePage(page)}>7 dage</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button color="primary" onClick={() => changePage(page)}>30 dage</Button>
                </Grid>
                <Grid item xs={4}>
                    <Button color="primary" onClick={() => changePage(page)}>90 dage</Button>
                </Grid>*/}
                <Grid item xs={12} className={classes.margTop}>
                    <Button fullWidth variant="contained" color="primary" onClick={() => changePage(page)}>{name}</Button>
                </Grid>
            </Grid>
        </div>
        )
    }

    const customerId = parseInt(TokenStorage.getCustomerId())

    return (
        <Fragment>
            <Switch>
                <Route exact path={`/statistics`}>
                    <Container maxWidth={false}>
                        <div className={classes.paper}>
                            <Typography component="h1" variant="h5">Statistik</Typography>
                        </div>
                        <div className={classes.boxArea}>
                            {statLinks(pageTransactions, "Posteringsoversigt")}
                            {statLinks(pageCardtypes, "Kreditkort")}
                            {statLinks(pageEmptyingCoins, "Mønttømninger")}
                            {statLinks(pageAlarms, "Alarmer og hændelser")}
                            {   (customerId == 9 || customerId == 22)
                            ?(
                            <>
                            {statLinks(pageDigitalLicenses, "Digitale licenser")}
                            </>
                            ):(
                            <>
                            </>
                            )}
                        </div>
                    </Container>
                </Route>

                <Route path={`/statistics/cardtypes`}>
                    <CardStatistics/>
                </Route>
                <Route path={`/statistics/emptying`}>
                    <EmptyingStatistics/>
                </Route>
                <Route path={`/statistics/transactions`}>
                    <TransactionStatistics/>
                </Route>
                <Route path={`/statistics/alarms`}>
                    <AlarmsStatistics/>
                </Route>
                { (customerId == 9 || customerId == 22)
                ?(
                <>
                <Route path={`/statistics/digital_licenses`}>
                    <DigitalLicensesStatistics />
                </Route>
                </>
                ) : (
                <>
                <Route> <div>Siden bliv ikke fundet</div></Route>
                </>)
                }
                <Route path={`/statistics/all`}>
                    <Statistics/>
                </Route>
                <Route> <div>Siden bliv ikke fundet</div></Route>
            </Switch>
        </Fragment>
    )
}

export default InternalNavigation
